// IMPORTANT! Whenever updating ./cdoBlockStyles.mjs, be sure to also update
// the styles here as well. The accessible styles can be generated using
// accessibleStylesGenerator.mjs.
// From this directory in your terminal, enter:
// - yarn add nearest-color
// - node accessibleStylesGenerator.mjs
// - yarn remove nearest-color

// Copy the values output by the script below.
export const protanopiaBlockStyles = {
  default: {colourPrimary: '#009175'},
  setup_blocks: {colourPrimary: '#FF4235'},
  event_blocks: {colourPrimary: '#009503'},
  loop_blocks: {colourPrimary: '#FF2E95'},
  logic_blocks: {colourPrimary: '#005FCC'},
  procedure_blocks: {colourPrimary: '#007702'},
  variable_blocks: {colourPrimary: '#AB0D61'},
  math_blocks: {colourPrimary: '#00489E'},
  text_blocks: {colourPrimary: '#00735C'},
  colour_blocks: {colourPrimary: '#0079FA'},
  sprite_blocks: {colourPrimary: '#810D49'},
  world_blocks: {colourPrimary: '#460B70'},
  behavior_blocks: {colourPrimary: '#005745'},
  location_blocks: {colourPrimary: '#D80D7B'},
  lab_blocks: {colourPrimary: '#5A0A33'},
};
export const deuteranopiaBlockStyles = {
  default: {colourPrimary: '#009175'},
  setup_blocks: {colourPrimary: '#FF4235'},
  event_blocks: {colourPrimary: '#009503'},
  loop_blocks: {colourPrimary: '#FF2E95'},
  logic_blocks: {colourPrimary: '#005FCC'},
  procedure_blocks: {colourPrimary: '#007702'},
  variable_blocks: {colourPrimary: '#AB0D61'},
  math_blocks: {colourPrimary: '#00489E'},
  text_blocks: {colourPrimary: '#005745'},
  colour_blocks: {colourPrimary: '#0079FA'},
  sprite_blocks: {colourPrimary: '#86081C'},
  world_blocks: {colourPrimary: '#460B70'},
  behavior_blocks: {colourPrimary: '#003D30'},
  location_blocks: {colourPrimary: '#5F0914'},
  lab_blocks: {colourPrimary: '#ED0DFD'},
};
export const tritanopiaBlockStyles = {
  default: {colourPrimary: '#009175'},
  setup_blocks: {colourPrimary: '#FF4235'},
  event_blocks: {colourPrimary: '#00735C'},
  loop_blocks: {colourPrimary: '#D80D7B'},
  logic_blocks: {colourPrimary: '#0079FA'},
  procedure_blocks: {colourPrimary: '#005A01'},
  variable_blocks: {colourPrimary: '#AB0D61'},
  math_blocks: {colourPrimary: '#6B069F'},
  text_blocks: {colourPrimary: '#00306F'},
  colour_blocks: {colourPrimary: '#460B70'},
  sprite_blocks: {colourPrimary: '#810D49'},
  world_blocks: {colourPrimary: '#8E06CD'},
  behavior_blocks: {colourPrimary: '#5A0A33'},
  location_blocks: {colourPrimary: '#ED0DFD'},
  lab_blocks: {colourPrimary: '#B40AFC'},
};
